import React from 'react';

export default class Icon extends React.Component {
  getClassName () {
    return 'typcn typcn-' + this.props.code + ' ' + this.props.className || '';
  }

  render () {
    return (<span className={this.getClassName()}></span>);
  }
};



// WEBPACK FOOTER //
// ./src/components/Components/Icon.js